// import routeMap from "../routeMap";
// import GetIcon from "../IconsComponent";

// export const getActivePaths = (routes, targetPath, parents = []) => {
//   for (let route of routes) {
//     // direct match
//     if (
//       route.path === targetPath ||
//       (route.path && targetPath.startsWith(route.path + "/"))
//     ) {
//       return [...parents, route.name];
//     }

//     // recurse
//     if (route.subRoutes?.length) {
//       const result = getActivePaths(
//         route.subRoutes,
//         targetPath,
//         [...parents, route.name]
//       );
//       if (result) return result;
//     }
//   }
//   return null;
// };




// export const findRouteKey = (path) => {
//     return (
//         Object.entries(routeMap)
//             .filter(([_, value]) => path.startsWith(value))
//             .sort((a, b) => b[1].length - a[1].length)?.[0]?.[0] || null
//     );
// };

// // CRITICAL: This function must NOT contain useMemo() or any React Hooks.
// // It should just calculate and return data.
// export const BuildNavigation = (menu, rujul_menu) => {
//     const formattedSubmenus = {};

//     rujul_menu.forEach(item => {
//         const title = item.menu_details?.title;
//         if (title && title !== "MASTER" && item.submenus?.allmenu) {
//             formattedSubmenus[title] = item.submenus.allmenu;
//         }
//     });

//     const rujulFormatted = {
//         menu_details: {
//             icon: "fa-solid fa-user-tie",
//             title: "ADMIN",
//         },
//         submenus: formattedSubmenus,
//     };

//     const route_arr =
//         formattedSubmenus && Object.keys(formattedSubmenus).length > 0
//             ? [...menu, rujulFormatted]
//             : [...menu];

//     let new_routes = [];
//     let alloweObjectIds = [];
    
//     if (Array.isArray(route_arr)) {
//         for (let row of route_arr) {
//             if (
//                 [
//                     "RMG",
//                     "PROJECT MANAGEMENT",
//                     "Human Resource",
//                     "TIME SHEET",
//                     "SUPPORT DESK",
//                     "PAYROLL",
//                     "ORGANIZATION",
//                     "Payroll Management",
//                     "ADMIN",
//                 ].includes(row.menu_details.title)
//             ) {
//                 let temp = {
//                     name: row.menu_details.title,
//                     exact: true,
//                     icon: GetIcon(row.menu_details.icon),
//                     subRoutes: [],
//                 };

//                 let subMenuArr = [];
//                 if (row.submenus && Object.keys(row.submenus).length > 0) {
//                     Object.keys(row.submenus).forEach((subkey) => {
//                         if (
//                             ![
//                                 "allmenu",
//                                 "Imports",
//                                 "Communication",
//                                 "Balance Sheet",
//                                 "Trial Balance",
//                                 "Profit & Loss",
//                             ].includes(subkey)
//                         ) {
//                             let subSubRoute = [];
//                             for (let childMenu of row.submenus[subkey]) {
//                                 if (
//                                     ![
//                                         "TnE Invoice list (Consulting and Content)",
//                                         "Update Invoice List (Training)",
//                                         "Internal Project",
//                                         "KPI Report (Training)",
//                                         "Cancel Leave Request",
//                                         "Incentive List (Training)",
//                                         "Update Invoice List (Consulting & Content)",
//                                         "Incentive List Fixed Bid",
//                                         "Team Incentives",
//                                         "Payroll Statements",
//                                         "Attendance Approvals",
//                                         "Attendance Statements",
//                                         "Accrued Leave Summary",
//                                         "Available Leave Summary",
//                                         "Support Ticket Resolution",
//                                         "Users Permission",
//                                         "Resource Requisition",
//                                         "Domains",
//                                         "Resource Requisition Approval",
//                                         "Employee Report",
//                                         "Announcement",
//                                         "Skills",
//                                         "Employee",
//                                         "Employee Qualification",
//                                         "Attendance Register",
//                                         "Daily Attendance",
//                                         "Employee Payrolls",
//                                         "Employee Payrolls List",
//                                         "Update Incentive List(Consulting & Content)",
//                                         "Incentive List",
//                                         "Employee Leave",
//                                         "Employee Shifts",
//                                         "Employee Leave List",
//                                         "Employee Shifts List",
//                                         "Payroll Journal Voucher",
//                                         "Payroll Journal Voucher List",
//                                         "Employee Payment",
//                                         "Company Policies",
//                                         "Widget",
//                                         "Log Statement",
//                                         "Active Login User",
//                                         "Transaction Log Statement",
//                                         "Dashboard Designer",
//                                         "Expense Settlement",
//                                         "Attendance Register",
//                                         "Scales",
//                                         "Attendance In Out Summary",
//                                         "Attendance Log Statement",
//                                         "Attendance Book Summary",
//                                     ].includes(childMenu.DiplayName)
//                                 ) {
//                                     alloweObjectIds.push(childMenu.ObjectType);
//                                     subSubRoute.push({
//                                         path: routeMap[childMenu.ObjectType],
//                                         name: childMenu.DiplayName,
//                                         icon: GetIcon(childMenu.Icon?.trim() || childMenu.Icon),
//                                     });
//                                 }
//                             }
//                             subMenuArr.push({
//                                 name: subkey,
//                                 icon: GetIcon(row.submenus[subkey][0].subGroupMenuIcon),
//                                 subRoutes: subSubRoute,
//                             });
//                         }
//                     });

//                     temp.subRoutes = subMenuArr;
//                 }

//                 if (row.submenus?.allmenu) {
//                     for (let first_row of row?.submenus?.allmenu) {
//                         if (
//                             ![
//                                 "Attendance Register",
//                                 "Attendance In Out Summary",
//                                 "Attendance Log Statement",
//                                 "Attendance Book Summary",
//                                 "Holiday",
//                                 "Forum",
//                                 "Announcement",
//                                 "TnE Invoice list (Consulting and Content)",
//                                 "TnE Invoice List (Training)",
//                                 "Update Invoice List (Training)",
//                                 "Invoice List (Training)",
//                                 "Employee Qualification",
//                                 "Attendance Status",
//                                 "HR Calendars",
//                                 "Company Policies",
//                                 "Skills",
//                                 "Employee Report",
//                                 "Employee List",
//                                 "Daily Attendance",
//                                 "Mark Attendance",
//                                 "HR Incentive List",
//                             ].includes(first_row.DiplayName)
//                         ) {
//                             alloweObjectIds.push(first_row.ObjectType);
//                             subMenuArr.push({
//                                 path: routeMap[first_row.ObjectType],
//                                 name: first_row.DiplayName,
//                                 icon: GetIcon(first_row.Icon?.trim() || first_row.Icon),
//                             });
//                         }
//                     }
//                 }

//                 temp.subRoutes = subMenuArr;
//                 new_routes.push(temp);
//             }
//         }
//     }

//     return { new_routes, alloweObjectIds };
// };

// export const actionsArray = [
//     "/dashboard",
//     "/",
//     "/change-password",
//     "/candidate-details",
//     "/special-leave",
//     "/candidate-details-verify",
//     "/view-job-description",
//     "/change-password",
//     "/RMG/employees",
//     "/RMG/sub-contractors",
//     "/RMG/employees/view/",
//     "/addfeedback",
//     "/view-feedbacks",
//     "/feedback-link-expire",
//     "/feedback-submitted",
//     "/offer-accepted",
//     "/dashboard",
//     "/",
//     "/candidate-details",
//     "/special-leave",
//     "/attendanceCalender",
//     "/50881180195049806954114046419509",
//     "/leave-approves",
//     '/forthcoming',
//     '/whatsnew',
//     '/achievers',
//     '/achievers/leaderboard',
//     '/apply/special-leave',
//     '/approve/special-leave'
// ];

// export const checkAction = (path) =>
//     actionsArray.some(route =>
//         path === route ||
//         path.startsWith(route + "/") ||
//         route.startsWith(path + "/")
//     );



import routeMap from "../routeMap";
import GetIcon from "../IconsComponent";

export const actionsArray = [
    "/dashboard",
    "/",
    "/change-password",
    "/candidate-details",
    "/special-leave",
    "/candidate-details-verify",
    "/view-job-description",
    "/RMG/employees",
    "/RMG/sub-contractors",
    "/RMG/employees/view/",
    "/addfeedback",
    "/view-feedbacks",
    "/feedback-link-expire",
    "/feedback-submitted",
    "/offer-accepted",
    "/attendanceCalender",
    "/50881180195049806954114046419509",
    "/508811801950498069541140464195090",
    "/leave-approves",
    '/forthcoming',
    '/whatsnew',
    '/achievers',
    '/achievers/leaderboard',
    '/apply/special-leave',
    '/approve/special-leave',
    '/employee-profile',
    '/employee/feedback-form',
    '/knowledge-sharing',
    '/candidate-details-ta-verify'
    // '/annual-appraisal-report',
    // '/annual-bonus-report'
];

export const getActivePaths = (routes, targetPath, parents = []) => {
    for (let route of routes) {
        if (
            route.path === targetPath ||
            (route.path && targetPath.startsWith(route.path + "/"))
        ) {
            return [...parents, route.name];
        }

        if (route.subRoutes?.length) {
            const result = getActivePaths(
                route.subRoutes,
                targetPath,
                [...parents, route.name]
            );
            if (result) return result;
        }
    }
    return null;
};

export const findRouteKey = (path) => {
    const entries = Object.entries(routeMap);
    const match = entries
        .filter(([_, value]) => {
            const normalizedPath = path.replace(/\/$/, "");
            const normalizedValue = value.replace(/\/$/, "");
            return normalizedPath === normalizedValue || normalizedPath.startsWith(normalizedValue + "/");
        })
        .sort((a, b) => b[1].length - a[1].length)[0];
        
    return match ? match[0] : null;
};

export const checkAction = (path) =>
    actionsArray.some(route =>
        path === route ||
        path.startsWith(route + "/") ||
        route.startsWith(path + "/")
    );

export const BuildNavigation = (menu, rujul_menu) => {
    const formattedSubmenus = {};

    rujul_menu.forEach(item => {
        const title = item.menu_details?.title;
        if (title && title !== "MASTER" && item.submenus?.allmenu) {
            formattedSubmenus[title] = item.submenus.allmenu;
        }
    });

    const rujulFormatted = {
        menu_details: {
            icon: "fa-solid fa-user-tie",
            title: "ADMIN",
        },
        submenus: formattedSubmenus,
    };

    const route_arr =
        formattedSubmenus && Object.keys(formattedSubmenus).length > 0
            ? [...menu, rujulFormatted]
            : [...menu];

    let new_routes = [];
    let alloweObjectIds = [];
    
    if (Array.isArray(route_arr)) {
        for (let row of route_arr) {
            const allowedGroups = [
                "RMG", "PROJECT MANAGEMENT", "Human Resource", "TIME SHEET", 
                "SUPPORT DESK", "PAYROLL", "ORGANIZATION", "Payroll Management", "ADMIN"
            ];

            if (allowedGroups.includes(row.menu_details.title)) {
                let temp = {
                    name: row.menu_details.title,
                    exact: true,
                    icon: GetIcon(row.menu_details.icon),
                    subRoutes: [],
                };

                let subMenuArr = [];
                if (row.submenus && Object.keys(row.submenus).length > 0) {
                    Object.keys(row.submenus).forEach((subkey) => {
                        const blacklistedSubkeys = ["allmenu", "Imports", "Communication", "Balance Sheet", "Trial Balance", "Profit & Loss"];
                        
                        if (!blacklistedSubkeys.includes(subkey)) {
                            let subSubRoute = [];
                            for (let childMenu of row.submenus[subkey]) {
                                const blacklistedItems = [
                                    "TnE Invoice list (Consulting and Content)", "Update Invoice List (Training)", 
                                    "Internal Project", "KPI Report (Training)", "Cancel Leave Request", 
                                    "Incentive List (Training)", "Update Invoice List (Consulting & Content)", 
                                    "Incentive List Fixed Bid", "Team Incentives", "Payroll Statements", 
                                    "Attendance Approvals", "Attendance Statements", "Accrued Leave Summary", 
                                    "Available Leave Summary", "Support Ticket Resolution", "Users Permission", 
                                    "Resource Requisition", "Domains", "Resource Requisition Approval", 
                                    "Employee Report", "Announcement", "Skills", "Employee", 
                                    "Employee Qualification", "Attendance Register", "Daily Attendance", 
                                    "Employee Payrolls", "Employee Payrolls List", "Update Incentive List(Consulting & Content)", 
                                    "Incentive List", "Employee Leave", "Employee Shifts", "Employee Leave List", 
                                    "Employee Shifts List", "Payroll Journal Voucher", "Payroll Journal Voucher List", 
                                    "Employee Payment", "Company Policies", "Widget", "Log Statement", 
                                    "Active Login User", "Transaction Log Statement", "Dashboard Designer", 
                                    "Expense Settlement", "Attendance Register", "Scales", 
                                    "Attendance In Out Summary", "Attendance Log Statement", "Attendance Book Summary"
                                ];

                                if (!blacklistedItems.includes(childMenu.DiplayName)) {
                                    alloweObjectIds.push(childMenu.ObjectType);
                                    subSubRoute.push({
                                        path: routeMap[childMenu.ObjectType],
                                        name: childMenu.DiplayName,
                                        icon: GetIcon(childMenu.Icon?.trim() || childMenu.Icon),
                                    });
                                }
                            }
                            subMenuArr.push({
                                name: subkey === "Recruitment Process" ? "TA" : subkey,
                                icon: GetIcon(row.submenus[subkey][0].subGroupMenuIcon),
                                subRoutes: subSubRoute,
                            });
                        }
                    });

                    temp.subRoutes = subMenuArr;
                }

                if (row.submenus?.allmenu) {
                    for (let first_row of row?.submenus?.allmenu) {
                        const blacklistedAllMenu = [
                            "Attendance Register", "Attendance In Out Summary", "Attendance Log Statement", 
                            "Attendance Book Summary", "Holiday", "Forum", "Announcement", 
                            "TnE Invoice list (Consulting and Content)", "TnE Invoice List (Training)", 
                            "Update Invoice List (Training)", "Invoice List (Training)", 
                            "Employee Qualification", "Attendance Status", "HR Calendars", 
                            "Company Policies", "Skills", "Employee Report", "Employee List", 
                            "Daily Attendance", "Mark Attendance", "HR Incentive List"
                        ];

                        if (!blacklistedAllMenu.includes(first_row.DiplayName)) {
                            alloweObjectIds.push(first_row.ObjectType);
                            subMenuArr.push({
                                path: routeMap[first_row.ObjectType],
                                name: first_row.DiplayName,
                                icon: GetIcon(first_row.Icon?.trim() || first_row.Icon),
                            });
                        }
                    }
                }

                temp.subRoutes = subMenuArr;
                new_routes.push(temp);
            }
        }
    }

    return { new_routes, alloweObjectIds };
};

// export default 